<template>
      <v-row v-if="!['admin', 'editor'].includes(currentPermission.privilegeLevel)"
          align="center"
          justify="center"
      >
          <v-col
          cols="12"
          sm="8"
          md="5"
          >
              <AccessDeniedCard/>
          </v-col>
      </v-row>
      <v-container v-else fluid class="pt-0">
          <ManageCardholders/>
          <p class="text-center"><v-btn elevation="0" width="250" to="/" color="primary" large class="text-body-1">Done</v-btn></p>
          <v-footer padless absolute="" color="transparent">
            <v-col
              class="text-center"
              cols="12"
            >
              <span class="text-caption grey--text"> © Pappyon Pty Ltd {{ new Date().getFullYear() }}</span>
              <a class="text-caption grey--text mx-8 text-decoration-none" href="https://pappyon.com/contact/">Contact</a>
              <a class="text-caption grey--text text-decoration-none" href="https://pappyon.com/terms-of-use/">Privacy & Terms</a>
            </v-col>
          </v-footer>
        <v-footer padless absolute="" color="transparent">
          <v-col
            class="text-center"
            cols="12"
          >
            <span class="text-caption grey--text"> © Pappyon Pty Ltd {{ new Date().getFullYear() }}</span>
            <a class="text-caption grey--text mx-8 text-decoration-none" href="https://pappyon.com/contact/">Contact</a>
            <a class="text-caption grey--text text-decoration-none" href="https://pappyon.com/terms-of-use/">Privacy & Terms</a>
          </v-col>
        </v-footer>
      </v-container>
</template>
<script>
// @ is an alias to /src
import ManageCardholders from '@/components/manageCardholders'
import AccessDeniedCard from '@/components/AccessDeniedCard'
import { mapGetters } from 'vuex'

export default {
  name: 'OnboardCardholders',
  components: {
    ManageCardholders,
    AccessDeniedCard
  },
  computed: mapGetters(['currentPermission',]),
}
</script>
